import { render, staticRenderFns } from "./UpdateDay.vue?vue&type=template&id=9160be5e&"
import script from "./UpdateDay.vue?vue&type=script&lang=js&"
export * from "./UpdateDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports